import styled from 'styled-components';

import { brandFont } from 'styles/brand-font';

export const PricePerContainer = styled.div`
  margin-block-start: 1rem;
`;

export const PricePerLine = styled.div`
  text-align: center;
  color: ${({ theme }) => theme.token('text-default')};
  font: ${brandFont.headerOne};
  margin-block-start: 0.3rem;
  font-weight: 300;
  font-size: 1.1rem;
  line-height: 1.25rem;
  text-transform: none;
`;
